import React, { useContext, useState, useEffect, useRef } from "react"
import { AuthContext } from "../context/AuthContext"
import {
    collection,
    addDoc,
    setDoc,
    doc,
    updateDoc,
    serverTimestamp,
    arrayUnion
} from "firebase/firestore"
import { db } from "../firebase"
import { handleUpload, onAnalyzeImages } from "../helpers/HelperFunctions"
import AddressAutocompleteProvider from "./helperComponents/AddressAutocompleteProvider"
import { getAddressData, getMarkerCoordinates, getZipCode, getNeighborhood } from "../helpers/HelperFunctions"
import spinner from "../assets/horizontal-loader2.svg"
import DndImage from "./helperComponents/DndImage"
import {closestCorners, DndContext, KeyboardSensor, PointerSensor, TouchSensor, useSensor, useSensors} from "@dnd-kit/core"
import {SortableContext, arrayMove, sortableKeyboardCoordinates, rectSortingStrategy} from "@dnd-kit/sortable"

// const { ImageAnalysisClient } = require('@azure-rest/ai-vision-image-analysis');
// const createClient = require('@azure-rest/ai-vision-image-analysis').default;
// const { AzureKeyCredential } = require('@azure/core-auth');

// const endpoint = process.env['VISION_ENDPOINT'];
// const key = process.env['VISION_KEY'];
// const endpoint = "https://phreesh.cognitiveservices.azure.com/";
// const key = "7VNFJ9MCdrPgwDhAGovP8puRSqwSZqEqK9v912ojquFUa1mRtJwKJQQJ99BJACYeBjFXJ3w3AAAFACOGUlI2";

// const credential = new AzureKeyCredential(key);
// const client = createClient(endpoint, credential);

const InputListing = ({disabled}) => {
    const { currentUser } = useContext(AuthContext)
    const [title, setTitle] = useState("")
    const [description, setDescription] = useState("")
    const [price, setPrice] = useState("")
    const [category, setCategory] = useState("")
    const [condition, setCondition] = useState("")
    const [address, setAddress] = useState(currentUser.address)
    const [uploadFiles, setUploadFiles] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    // const [geocoder, setGeocoder] = useState("")
    // const [imageUrls, setImageUrls] = useState([])

    // const loader = new Loader({
    //     apiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
    //     version: "weekly",
    // });

    // **Used for when address was manually entered**
    // const concatAddress = (address1, address2, city, state, zipCode) => {
    //     const addressArray = [address1, address2, city, state, zipCode]
    //     const addressStr = addressArray.join(" ")
    //     console.log(addressStr)
    //     return addressStr
    // }


    // const handleFileChange = (e) => {
    //     setFile(e.target.files[0]);
    //     setTags([]);
    //     setError('');
    //   };

    // const features = [
    //     'Caption',
    //     'Read',
    //     'Tags'
    //   ];
    
    // const handleImageAnalysis = async(imageUrl) => {
    //     const result = await client.path('/imageanalysis:analyze').post({
    //         body: {
    //             url: imageUrl
    //         },
    //         queryParameters: {
    //             features: features,
    //             'language': 'en',
    //             'gender-neutral-captions': 'true',
    //             'smartCrops-aspect-ratios': [0.9, 1.33]
    //         },
    //         contentType: 'application/json'
    //     });
    //     return result
    // }

    // const iaResult = handleImageAnalysis(imageUrls[0])
    // console.log(iaResult)

    const blobUrls = useRef([])
    useEffect(() => {
        return () => {
            console.log("Cleaning up blob URLs...")
            console.log(blobUrls)
            blobUrls.current.forEach(url => URL.revokeObjectURL(url))
        }
    }, [])

    const onSubmitForm = async(e) => {
        e.preventDefault()
        setIsLoading(true)

        const imageFilesArray = uploadFiles.map(image => image.file)
        const imageUrls = await handleUpload(imageFilesArray)

        const returnedTags = await onAnalyzeImages(imageUrls)
        const iaResult = [...new Set([...returnedTags, ...returnedTags.join(' ').toLowerCase().split(/[\s.,!~/-]/)])]

        const addressData = await getAddressData(address)
        const zipCode = getZipCode(addressData.addressComponents)
        const neighborhood = getNeighborhood(addressData.addressComponents)
        const markerCoordinates = getMarkerCoordinates(addressData.coordinates)
        try{
            const titleSplit = title.toLowerCase().split(/[\s.,!~/-]/)
            const titleTags = [...new Set([...titleSplit])]
            const descriptionSplit = description.toLowerCase().split(/[\s.,!~/-]/)
            const descriptionTags = [...new Set([...descriptionSplit])]
            let docRef

            try {
                docRef = await addDoc(
                    collection(db, "listings"), 
                    {
                        title: title,
                        titleTags: titleTags,
                        description: description,
                        descriptionTags: descriptionTags,
                        aiTags: iaResult,
                        price: price,
                        category: category,
                        condition: condition,
                        user: {
                            userId: currentUser.uid,
                            firstName: currentUser.firstName
                        },
                        image_urls: imageUrls,
                        active: true,
                        markerCoordinates: markerCoordinates,
                        location: neighborhood,
                        zipCode: zipCode,
                        createdAt: serverTimestamp()
                    }
                )
            } catch (err) {
                alert(`Error creating listing: ${err}`)
                return
            }

            try{
                await updateDoc(doc(db, "listings", docRef.id), {
                    id: docRef.id
                })
            } catch (err) {
                alert(`Error updating listings: ${err}`)
                return
            }

            try{
                await updateDoc(doc(db, "users", currentUser.uid), {
                    activeListings: arrayUnion(docRef.id)
                })
            } catch (err) {
                alert(`Error updating users: ${err}`)
                return
            }

            try {
                await setDoc(
                    doc(db,`listings/${docRef.id}/private`, "data"),
                    {
                        addressData: addressData,
                        bidders: [],
                        chatrooms: [],
                        userEmail: currentUser.email,
                    }
                )
            } catch (err) {
                alert(`Error updating private data on listing: ${err}`)
                return
            }
            
            window.location.href = `/item/${docRef.id}`
        } catch(err) {
            alert(err)
        } finally {
            setIsLoading(false)
        }
    }

    const MAX_IMAGES = 6
    const handleImageChange = (e) => {
        if(e.target.files) {
            const filesArray = Array.from(e.target.files).map((file) => {
                const blob = URL.createObjectURL(file)
                blobUrls.current.push(blob)
                return {
                    file: file,
                    tempUrl: blob
                }
            })
            console.log(e.target.files)
            console.log(filesArray)
            if (uploadFiles.length + filesArray.length > MAX_IMAGES) {
                alert(`You can only have a maximum of ${MAX_IMAGES} images`)
                return
            }
            setUploadFiles((prevImages) => prevImages.concat(filesArray))
            // setTempFileUrls((prevImages) => prevImages.concat(filesArray))
        }
    }

    const onImageDelete = (e) => {
        console.log('asdf')
        const imageUrl = e.target.getAttribute("imageurl")
        const index = uploadFiles.findIndex(file => file.tempUrl === imageUrl)
        const uploadFilesCopy = [...uploadFiles]
        uploadFilesCopy.splice(index, 1)
        setUploadFiles(uploadFilesCopy)
    }
    const getImagePos = (id) => uploadFiles.findIndex((file) => file.tempUrl===id)
    const handleDragEnd = (event) => {
        const { active, over } = event

        if (active.id===over.id) return

        setUploadFiles((prevUploadFiles) => {
            const originalPos = getImagePos(active.id)
            const newPos = getImagePos(over.id)

            return arrayMove(prevUploadFiles, originalPos, newPos)
        })
    }
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 5
            }
        }),
        useSensor(TouchSensor, {
            activationConstraint: {
                distance: 5
            }
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates
        })
    )

    return (
        <>
            {currentUser.emailVerified ? 
            <></> :
            <div className='alert alert-danger'>Please verify your e-mail to unlock full access to Phreesh!</div>
            }
            <form onSubmit={onSubmitForm}>
                <div>Title</div>
                <input 
                    type="text"    
                    className="form-input"
                    maxLength={50}
                    onChange={
                        e=> setTitle(e.target.value)
                    }
                    required
                    disabled={disabled}
                />
                <div>Price</div>
                <input 
                    type="number"    
                    className="form-input"
                    onChange={
                        e=> setPrice(e.target.value)
                    }
                    disabled={disabled}
                />
                <div>Category</div>
                <select
                    type="text"    
                    className="form-input"
                    onChange={
                        e=> setCategory(e.target.value)
                    }
                    required
                    disabled={disabled}
                    value={category}
                >
                    <option value="" disabled hidden>Select a Category</option>
                    <option value="Home and Kitchen">Home and Kitchen</option>
                    <option value="Electronics">Electronics</option>
                    <option value="Women's Clothing and Accessories">Women's Clothing and Accessories</option>
                    <option value="Men's Clothing and Accessories">Men's Clothing and Accessories</option>
                    <option value="Baby and Kids">Baby and Kids</option>
                    <option value="Auto Parts and Accessories">Auto Parts and Accessories</option>
                    <option value="Sports and Fitness">Sports and Fitness</option>
                    <option value="Tools and Garden">Tools and Garden</option>
                    <option value="Other">Other</option>
                </select>
                <div>Condition</div>
                <select
                    type="text"    
                    className="form-input"
                    onChange={
                        e=> setCondition(e.target.value)
                    }
                    required
                    disabled={disabled}
                    value={condition}
                >
                    <option value="" disabled hidden>Select a Condition</option>
                    <option value="New">New</option>
                    <option value="Used - Like New">Used - Like New</option>
                    <option value="Used - Good">Used - Good</option>
                    <option value="Used - Fair">Used - Fair</option>
                </select>
                <div>Description</div>
                <textarea 
                    rows="4"    
                    className="form-input large-input"
                    maxLength={800}
                    onChange={
                        e=> setDescription(e.target.value)
                    }
                    required
                    disabled={disabled}
                />
                <div>Pick-up Location</div>
                <AddressAutocompleteProvider address={address} setAddress={setAddress}/>
                {/* <UploadWidget></UploadWidget> */}

                <div>
                    <input type="file" id="file-upload" className="hidden-file-input" onChange={handleImageChange} multiple required disabled={disabled}/>
                    <label htmlFor="file-upload" className="file-upload-label btn btn-secondary">
                        Choose Images
                    </label>
                    {/* <div className="photos-preview">{renderPhotos(tempFileUrls)}</div> */}
                    <div className="edit-images-carousel"> 
                        <DndContext sensors={sensors} collisionDetection={closestCorners} onDragEnd={handleDragEnd}>
                            <div className="dnd-grid">
                                <SortableContext items={uploadFiles.map(file => file.tempUrl)} strategy={rectSortingStrategy}>
                                    {uploadFiles && uploadFiles.map((file, i) => 
                                        (<DndImage key={`edit-images-box-${i}`} id={file.tempUrl} imageurl={file.tempUrl} onImageDelete={onImageDelete}/>)
                                    )}
                                </SortableContext>
                            </div>
                        </DndContext>
                    </div>
                </div>

                <button type="submit" className="btn btn-primary input-listing-button" disabled={disabled || isLoading}>
                    {isLoading ? 
                        <img src={spinner} alt="Loading..." className="button-spinner" /> : 
                        <>Submit</>
                    }
                </button>
            </form>
        </>
    )
}

export default InputListing